module.exports = __webpack_public_path__ + "media/images/team-48eb6356266e3728024b242ba4316f9b.svg";